import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { SpecraTabBar } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { POTENTIAL_ISSUES_COPY } from '../_shared/constants/sectionCopy';
import { IssuesTab } from './IssuesTab';
import { RisksTab } from './RisksTab';
import { SubcontractorReviewsTab } from './SubcontractorReviewsTab';
const SUB_TABS = [
    'risks',
    'issues',
    'sub-reviews'
];
const PANELS = {
    risks: RisksTab,
    issues: IssuesTab,
    'sub-reviews': SubcontractorReviewsTab
};
export function RiskTab({ programId }) {
    // ?tab= deep-links a sub-tab — the assigned-actions feed's ISSUE/RISK
    // destinations land here (see DocsTab.tsx for the same idiom).
    const [searchParams] = useSearchParams();
    const requested = searchParams.get('tab');
    const [active, setActive] = useState(requested && SUB_TABS.includes(requested) ? requested : 'risks');
    // Only the active panel mounts — the same lifecycle Radix TabsContent had.
    const ActivePanel = PANELS[active];
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(SpecraTabBar, {
                label: "Risk sections",
                value: active,
                onValueChange: setActive,
                options: [
                    {
                        value: 'risks',
                        label: POTENTIAL_ISSUES_COPY.label,
                        testId: Testids.deliveryRisk.subTabRisks
                    },
                    {
                        value: 'issues',
                        label: 'Issues',
                        testId: Testids.deliveryRisk.subTabIssues
                    },
                    {
                        value: 'sub-reviews',
                        label: 'Sub Reviews',
                        testId: Testids.deliveryRisk.subTabSubReviews
                    }
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "mt-6",
                children: /*#__PURE__*/ _jsx(ActivePanel, {
                    programId: programId
                })
            })
        ]
    });
}
